// @flow
import { Map as ImmutableMap, Record } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

import { getLogger } from 'utils/logger';

const log = getLogger('data/qcsSyncResourceSagaHelpers');

export type QcsSyncResourceStoreProps = {
  resourcesById: ImmutableMap<string, any>,

  resourceName: ?string,
  lastSyncDate: ?string,
  loadPending: boolean,
  isLoading: boolean,
  error: any,
};
export type QcsSyncResourceStore = RecordOf<QcsSyncResourceStoreProps>;
export const mkQcsSyncResourceStore: RecordFactory<QcsSyncResourceStoreProps> =
  Record({
    resourcesById: new ImmutableMap(),

    resourceName: null,
    lastSyncDate: null,
    loadPending: true,
    isLoading: false,
    error: undefined,
  });

// SYNC_SIDE_EFFECTS
export type QcsSyncResourcesSyncActionsProps = {
  syncDeleteAction: any,
  // add additional actions here
}
export type QcsSyncResourcesSyncActions = RecordOf<QcsSyncResourcesSyncActionsProps>;
export const mkQcsSyncResourcesSyncActions: RecordFactory<QcsSyncResourcesSyncActionsProps> =
  Record({
    syncDeleteAction: undefined,
  });


export type QcsSyncResourcesPayloadProps = {
  resources: Array<*>,
  doMerge: boolean,
  lastSyncDate: ?string,
  error: any,
  asyncDispatch: any,
  syncActions: any,
}
export type QcsSyncResourcesPayload = RecordOf<QcsSyncResourcesPayloadProps>;
export const mkQcsSyncResourcesPayload: RecordFactory<QcsSyncResourcesPayloadProps> =
  Record({
    resources: [],
    doMerge: false,
    lastSyncDate: null,
    error: undefined,
    asyncDispatch: null,       // SYNC_SIDE_EFFECTS
    syncActions: null,         // SYNC_SIDE_EFFECTS
  });

export type PollConfigProps = {
  isComplete: (any) => boolean,
  attempts: number,
  pause: number,
}
export type PollConfig = RecordOf<PollConfigProps>;
export const mkPollConfig: RecordFactory<PollConfigProps> =
  Record({
    isComplete: () => false,
    attempts: 10,
    pause: 300,
  });

type QcsSyncResourcesConfigProps = {
  resourceName: string,
  resourceBaseUrl: string,
  axiosConfig: any,
  getLastSyncDate: (any) => any;
  pollConfig: PollConfig,

  transformResponseToResources: (any) => any,
  transformResourceWithResponse: (any, any) => any,
  transformResourcesWithResponse: (any, any) => any,
  transformResourceToRequestData: (any) => any,
  transformResourcesToRequestData: (any) => any,

  successAction: (any, actionMetadata: Object) => void,
  failureAction: (any, actionMetadata: Object) => void,
};
export type QcsSyncResourcesConfig = RecordOf<QcsSyncResourcesConfigProps>;
export const mkQcsSyncResourceConfig: RecordFactory<QcsSyncResourcesConfigProps> =
  Record({
    resourceName: 'unknown-resource',
    resourceBaseUrl: 'resources',
    axiosConfig: undefined,
    getLastSyncDate: () => { log.error('getLastSyncDate must be configured'); return null; },
    pollConfig: mkPollConfig(),

    transformResponseToResource: (response) => response && response.data && new (Record(response.data))(response.data),
    transformResponseToResources: (response) => response && response.data && response.data.resources && response.data.resources.map((resource) => new (Record(resource))(resource)),
    transformResourceWithResponse: (resource, response) => resource && resource.set ? resource.set('id', response && response.data && response.data.id) : { ...resource, id: response && response.data && response.data.id },
    transformResourcesWithResponse: (resources, response) =>
      response.data.items.map((item) => {

        // TODO: This method requires work to handle all the different statuses and the action they require.
        // TODO: Also more work if we want to handle optimistic updates (and rollback on failures).

        let resource = null;
        if (item.resource.clientId) {
          resource = resources.find((fResource) => fResource.clientId === item.resource.clientId);
          resource = resource.set ? resource.set('id', item.resource.id) : { ...resource, id: item.resource.id };
        } else {
          resource = resources.find((fResource) => fResource.id === item.resource.id);
        }
        return resource;
      }),

    transformResourceToRequestData: (resource) => resource && resource.toJS ? resource.toJS() : resource,
    transformResourcesToRequestData: (resources) => ({
      resources: resources.reduce((list, resource) => {
        list.push(resource.toJS ? resource.toJS() : resource);
        return list;
      }, []),
    }),

    successAction: () => { log.error('successAction must be configured'); },
    failureAction: () => { log.error('failureAction must be configured'); },
  });




